<template>
<div>

    <!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading show="true" :pageTitle="isNewTemplate ? 'Neues Email Template anlegen' : template.name"></page-heading>

    	<div class="columns">

    		<div class="col-main">

    			<template v-if="isLoading">
    				<div class="loadingContainer has-text-centered">
    					<loading-indicator></loading-indicator>
    				</div>
    			</template>

                <template v-else>

                    <div class="box">

                        <!-- TEMPLATES -->
                        <div class="control is-horizontal">
                            <div class="control-label">
                                <label-name labelKey="EMAIL-TEMPLATE_TYPES"></label-name>
                            </div>
                            <div class="control">
                                <span class="select is-medium">
                                    <select v-model="template.type">
                                        <option v-for="(templateType, index) in mailTemplateTypes" :value="templateType.id">{{ $t('EMAIL-TEMPLATE_TYPE-' + templateType.name) }}</option>
                                    </select>
                                </span>
                            </div>
                        </div>

                        <!-- template name -->
                        <div class="control is-horizontal">
                            <div class="control-label">
                                <label-name labelKey="TEMPLATE-NAME"></label-name>
                            </div>
                            <div class="control">
                                <input id="TEMPLATE-NAME" class="input is-medium" type="text" v-model="template.name">
                            </div>
                        </div>

                        <br />

                        <!-- template subject -->
                        <div class="control is-horizontal">
                            <div class="control-label">
                                <label-name labelKey="TEMPLATE-SUBJECT"></label-name>
                            </div>
                            <div class="control">
                                <input id="TEMPLATE-SUBJECT" class="input is-medium" type="text" v-model="template.subject">
                            </div>
                        </div>

                        <!-- template body -->
                        <div class="control is-horizontal">
                            <div class="control-label">
                                <label-name labelKey="TEMPLATE-BODY"></label-name>
                            </div>
                            <div class="control froalaRTE froalaPlain">

									<froala id="froala" ref="froala" :tag="'textarea'" :config="froalaConfig" v-model="template.body"></froala>

									<!--
									<quill-editor
									v-model="template.body"
									ref="quillEditor"
									:options="editorOption"
									key="quill">
									</quill-editor>
									-->
                            </div>

                        </div>

                    </div>
					<!--
					<div style="width: 80%; background: #f5f5f5; padding: 20px;">
						{{ template.body }}
					</div>
					-->

                </template>


            </div>

            <div class="col-aside">

                <div class="sidebox">
                    <affix :offset="0" boundary=".col-aside">
                        <!--<custom-button type="blue" icon="fa-save" name="SECTION-BTN_SAVE" :loading="isSaving" @click.native="submitForm"></custom-button>-->
    					<custom-button type="blue" icon="icon-ak-speichern" name="TEMPLATE-BTN_SAVE" :loading="isSaving" @click.native="submitForm"></custom-button>
                    </affix>
                </div>


            </div>

        </div>

    </template>


</div>

</template>


<script>
// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala)


export default {

	name: 'template',

	components: {
		VueFroala
	},

	data() {

		return {
            isLoading: false,
            isSaving: false,
            isNewTemplate: false,
            template: {},

			froalaConfig: {
                key: '',
                toolbarButtons: ['bold', 'italic', 'underline', '|', 'insertLink', '|', 'subscript', 'superscript', '|', 'align', '|', 'undo', 'redo'],
                placeholderText: 'Schreiben Sie hier Ihren Text ...',
				wordPasteModal: false,
				pastePlain: true,
                initOnClick: false,
				heightMin: 300,
				heightMax: 500,
				quickInsertButtons: [],
				quickInsertTags: [],
                language: 'de',
	            tableEditButtons: ['tableHeader', 'tableRemove', '|', 'tableRows', 'tableColumns', '-', 'tableCells', 'tableCellVerticalAlign', 'tableCellHorizontalAlign'],
                tableMultipleStyles: false,
                tableResizer: true,
				charCounterCount: false,
				// charCounterMax: 140,
                // quickInsertTags: [],        // disable quickInsertBar
            },

        }

    },

    computed: {

        mailTemplateTypes() {
            return this.$store.getters.getTermsByTaxonomy('MAIL_TEMPLATE_TYPES');
        }

    },


	created() {

		// set licence key for froala
		this.froalaConfig.key = this.$config.froalaKey;
		
        var templateID = parseInt(this.$route.params.templateID);

        if (templateID && Number.isInteger(templateID)) {

            this.entityGet('mailTemplate', templateID, {}, 'template');

        } else {

            this.isNewTemplate = true;
            this.template = {
                'type': 74
            }

        }

    },


    methods: {

        submitForm() {

            var self = this;

            this.entityCreateOrUpdate('mailTemplate', this.template)
                .then(function() {
                    self.$router.push({ path: '/einstellungen/email-templates' });
                });


        },

    }


}

</script>

<style>

	.ql-editor p {
		margin-bottom: 1rem;
	}
	.ql-toolbar.ql-snow {
	    border: 1px solid #ccc;
	    box-sizing: border-box;
	    padding: 8px;
		border-top-left-radius: 3px;
		border-top-right-radius: 3px;
	}
	.ql-container.ql-snow {
	    border: 1px solid #ccc;
	    border-bottom-right-radius: 3px;
		border-bottom-left-radius: 3px;
	}

	.froalaRTE p {
		margin-bottom: 15px;
	}
</style>


<style scoped>

</style>
